<template>
  <div id="app" class="app">
    <standby-layout v-if="isStandby"></standby-layout>
    <auth-layout v-else-if="isAuth"></auth-layout>
    <invoice-layout v-else-if="isInvoice"></invoice-layout>
    <layout v-else></layout>
  </div>
</template>

<script>
/*eslint-disable */
import Layout from 'components/layout/Layout'
import StandbyLayout from './components/layout/StandbyLayout'
import AuthLayout from './components/layout/AuthLayout'
import InvoiceLayout from './components/layout/InvoiceLayout'
import VuesticPreLoader from './components/vuestic-components/vuestic-preloader/VuesticPreLoader.vue'

export default {
  name: 'app',
  components: {
    StandbyLayout,
    VuesticPreLoader,
    AuthLayout,
    InvoiceLayout,
    Layout
  },
  computed: {
    isAuth () {
      return this.$route.path.match('auth')
    },
    isStandby () {
      return (!this.$store.state.settings || this.$store.state.settings.state === null || this.$store.state.settings.state === '0')
    },
    isInvoice () {
          return this.$route.path.match('invoice')
    }
  }
}
/* eslint-enable */
</script>

<style lang="scss">
  @import "sass/main";
  body {
    height: 100%;
    .app {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue